// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2p48J","col":"CardReaderDesc_col__1oM5F","label":"CardReaderDesc_label__32Mrp"};